import DashboardService from '../../services/dashboard.service'
export const setup = {
  namespaced: true,
  state: {
    TotalCompleted: 0,
    TotalCount: 0,
    Remaining: 0,
    portalSetupData: 0,
    progress: 0
  },
  mutations: {
    setStats (state, payload) {
      state.portalSetupData = payload.PortalSetupData
      state.progress = (payload.TotalCompleted / payload.TotalCount) * 100
      state.TotalCompleted = payload.TotalCompleted
      state.TotalCount = payload.TotalCount
      state.Remaining = payload.TotalCount - payload.TotalCompleted
    }
  },
  actions: {
    UpdatedStats ({ commit }) {
      DashboardService.getPortalSetupInformation().then(response => {
        if (!response) return
        const { TotalCompleted, TotalCount, PortalSetupData } = JSON.parse(response.request.response).Object
        commit('setStats', { TotalCompleted, TotalCount, PortalSetupData })
      })
    }
  },
  getters: {
    portalSetupData (state) {
      return state.portalSetupData
    },
    totalProgess (state) {
      return state.progress
    },
    totalCompleted (state) {
      return state.TotalCompleted
    },
    totalCount (state) {
      return state.TotalCount
    },
    remaining (state) {
      return state.Remaining
    },
    // Example: percentage completed
    completionPercentage (state) {
      if (state.TotalCount === 0) return 0
      return (state.TotalCompleted / state.TotalCount) * 100
    }
  }
}
